<template>
  <div>
    <b-table
      :items="rows"
      :fields="fields"
      :busy="loading"
      hover
      striped
      responsive
      show-empty
      empty-text="Платежей нет"
      tbody-tr-class="cursor-pointer"
      @row-clicked="open"
    >
      <template #cell(id)="{ item }">
        <router-link :to="{ name: 'payment-details', params: { id: item.id } }">
          #{{ item.id }}
        </router-link>
      </template>
      <template #cell(type)="{ item }">
        {{ typeLabels[item.type] || item.type }}
      </template>
      <template #cell(status)="{ item }">
        <b-badge :variant="statusVariant(item.status)">
          {{ item.status || '—' }}
        </b-badge>
      </template>
      <template #cell(amountKopecks)="{ item }">
        {{ formatMoney(item.amountKopecks) }}
        <small
          v-if="item.walletAmountKopecks"
          class="text-muted d-block"
        >+ кошелёк {{ formatMoney(item.walletAmountKopecks) }}</small>
      </template>
      <template #cell(entity)="{ item }">
        <span v-if="item.entityType">{{ entityLabels[item.entityType] || item.entityType }} #{{ item.entityId }}</span>
        <span
          v-else
          class="text-muted"
        >не привязан</span>
      </template>
      <template #cell(createdAt)="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template #cell(findings)="{ item }">
        <div
          v-for="finding in visibleFindings(item)"
          :key="finding.code"
          class="mb-25"
        >
          <b-badge :variant="severityVariants[finding.severity]">
            {{ finding.message }}
          </b-badge>
        </div>
      </template>
    </b-table>

    <b-pagination
      v-if="count > perPage"
      :value="page"
      :total-rows="count"
      :per-page="perPage"
      align="center"
      class="mt-1"
      @change="$emit('page', $event)"
    />
    <p
      v-if="count"
      class="text-muted text-center mb-0"
    >
      Всего: {{ count }}
    </p>
  </div>
</template>

<script>
import { BBadge, BPagination, BTable } from 'bootstrap-vue'
import {
  ENTITY_LABELS, SEVERITY_VARIANTS, TYPE_LABELS, formatDate, formatMoney, statusVariant,
} from '../payment-labels'

export default {
  name: 'PaymentsTable',
  components: { BBadge, BPagination, BTable },
  props: {
    rows: { type: Array, default: () => [] },
    count: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 20 },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      typeLabels: TYPE_LABELS,
      entityLabels: ENTITY_LABELS,
      severityVariants: SEVERITY_VARIANTS,
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'externalOrderId', label: 'Платёж ЮKassa' },
        { key: 'type', label: 'Тип' },
        { key: 'status', label: 'Статус' },
        { key: 'amountKopecks', label: 'Сумма' },
        { key: 'entity', label: 'За что' },
        { key: 'payerId', label: 'Плательщик' },
        { key: 'createdAt', label: 'Создан' },
        { key: 'findings', label: 'Диагноз' },
      ],
    }
  },
  methods: {
    formatDate,
    formatMoney,
    statusVariant,
    // a list can say what it knows from the record only; "applied" and "cancelled" are not worth a badge there
    visibleFindings(item) {
      return (item.findings || []).filter(finding => finding.severity !== 'info' || finding.code === 'ABANDONED_ATTEMPT')
    },
    open(item) {
      this.$router.push({ name: 'payment-details', params: { id: item.id } })
    },
  },
}
</script>
